import styled from "@emotion/styled";
import { Button, Form, Input, Modal, Space, TimePicker } from "antd";
import React, { useEffect } from "react";
import DescriptionForm from "./DescriptionForm";
import { ParkingListItems } from "@/services/interface";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

interface ModalParkingTimeProps {
  show: boolean;
  onClose: () => void;
  parkingListItems: ParkingListItems | undefined;
}

const ModalParkingTime = ({
  show,
  onClose,
  parkingListItems,
}: ModalParkingTimeProps) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      timeList: [{ time: undefined }],
    });
  }, []);

  return (
    <Modal
      title={`เวลาถึงจุดจอด ${parkingListItems?.name}`}
      open={show}
      maskClosable={false}
      onCancel={() => {
        onClose();
      }}
      style={{ top: 20 }}
      footer={[
        <Button key="back" onClick={() => onClose()}>
          ยกเลิก
        </Button>,
        <Button key="submit" type="primary" onClick={() => form.submit()}>
          บันทึก
        </Button>,
      ]}
    >
      <WrapperAll>
        <Form
          form={form}
          onFinish={() => {}}
          labelAlign="left"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          style={{ width: "100%", marginTop: 20 }}
        >
          <Form.List name="timeList">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <div
                    key={key}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 8,
                      alignItems: "baseline",
                    }}
                  >
                    <Form.Item
                      {...restField}
                      name={[name, "time"]}
                      rules={[{ required: true, message: "กรุณากรอกเวลาถึง" }]}
                      label="เวลาถึง"
                      style={{ width: "90%" }}
                    >
                      <TimePicker
                        size="middle"
                        format={"HH:mm"}
                        style={{ width: "100%" }}
                        placeholder="เลือกเวลารถถึงจุดจอด"
                      />
                    </Form.Item>

                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </div>
                ))}
                <Form.Item wrapperCol={{ span: 24 }} labelAlign="right">
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                      style={{ width: "50%" }}
                    >
                      เพิ่มเวลา
                    </Button>
                  </div>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </WrapperAll>
    </Modal>
  );
};

export default ModalParkingTime;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
